import api from '@/js/services/api';

export default {

    getEventsForSearch(search) {
        return api().get('/master-admin/calendar/events/get', {
            params: {
                search: search,
                calendarIds: []
            }
        })
    },

    getEventsForPeriod(period) {
        return api().get('/master-admin/calendar/events/get', {
            params: {
                period: period,
            }
        })
    },

    saveEvent(form) {
        return api().post(`/master-admin/calendar/event/store`, form)
    },
    deleteEvent(eventId) {
        return api().delete(`/master-admin/calendar/event/${eventId}/destroy`);
    },

    getCalendarList() {
        return api().get(`/master-admin/calendar/get`)
    },
    createCalendar(calendarInfo) {
        return api().post(`/master-admin/calendar/store`, calendarInfo)
    },

    updateCalendar(calendar_id, calendarInfo) {
        return api().put(`/master-admin/calendar/${calendar_id}/update`, calendarInfo)
    },

    updateSettings(settings) {
        return api().post(`/master-admin/calendar/settings/update`, settings)
    },

    deleteCalendarItem(id) {
        return api().delete(`/master-admin/calendar/${id}/destroy`);
    },

    getListOfUsersForCalendar() {
        return api().get('/user/get-users-for-calendar')
    },


}
